import SafeHtml from "../../content/SafeHtml";
import { useCabinetText, withCabinetContent, useCabinetContent } from "../../content/CabinetContentContext";
// import css from "./userCabinet.module.css";
// import {
//   collection,
//   query,
//   where,
//   getDocs,
//   updateDoc,
//   getDoc,
//   doc,
// } from "firebase/firestore";
// import BusinessPartnerOrders from "./BusinessPartnerOrders";
// import iconProp from "../../img/iconProp.png";
// import Group16 from "../../img/Group16.png";
// import Group17 from "../../img/smallGroup.png";
// import facForUs from "../../img/facForUs.png";
// import mailForSoc from "../../img/mailForSoc.png";
// import tgUser from "../../img/tgUser.png";
// import whatUser from "../../img/whatUser.png";
// import { useState, useEffect, useMemo } from "react";
// import WaitProd from "./waitProd";
// import discIcon from "../../img/discIcon.png";
// import { Link, useNavigate } from "react-router-dom";
// import { auth, db } from "../../firebase";
// import axios from "axios";
// import withUserData from "../HOK/withUserData";
// import { signOut } from "firebase/auth";
// import elefant from "../../img/elefant.png";
// import ViewProductCatalog from "../catalog/viewProductCatalog";
// import WaitProdLike from "./waitProdLike";
// import que from "../../img/que.png";
// import BlockReader from "./blockReader";
// import BlockMaister from "./blockMaister";
// import BlockBusiness from "./blockBusiness";
// import ChangeData from "./changeData";
// import useContentDoc from "../../hooks/useContentDoc";
// import UserChat from "../chat/UserChat";
// import UserChatBadge from "../chat/UserChatBadge";
// import CommercialNewsBanner from "../admin/main/CommercialNewsBanner";
// import BusinessInvoices from "./BusinessInvoices.jsx";
// import CabinetTilesDynamiс from "./CabinetTilesDynamic.jsx";
// import BlockLibrarian from "./BlockLibrarian.jsx";
// import LibraryOffersBanner from "./LibraryOffersBanner.jsx";
// import LibraryCatalogBanner from "./LibraryCatalogBanner.jsx";
// import RoleChangeFormModal from "./RoleChangeFormModal.jsx";
// const UserCabinet = ({
//   setAddressChanged,
//   addressChanged,
//   windowDimensions,
//   user,
//   userBd,
//   setCartCounterC,
//   visitedProducts,
//   setLikeCounterC,
// }) => {
//   const navigate = useNavigate();
//   const [selectedText, setSelectedText] = useState(1);
//   const [scrollHeight, setScrollHeight] = useState(0);
//   const [infoTg, setInfoTg] = useState(false);
//   const [tgId, setTgId] = useState("");
//   const [products, setProducts] = useState([]);
//   const [realUser, setRealUser] = useState(null);
//   const [orders, setOrders] = useState([]);
//   const [workFunc, setWorkFunc] = useState(false);
//   const [openChat, setOpenChat] = useState(false);
//   const [cheSetinings, setCheSetinings] = useState(false);
//   const [waitProdComponents, setWaitProdComponents] = useState([]);
//   const [showCabinetMenu, setShowCabinetMenu] = useState(false);
//   const [cabinetRequest, setCabinetRequest] = useState(() => {
//     try {
//       return JSON.parse(localStorage.getItem("cabinetRequest")) || null;
//     } catch {
//       return null;
//     }
//   });
//   const [selectedCabinetRole, setSelectedCabinetRole] = useState(null);
//   const [showRoleFormModal, setShowRoleFormModal] = useState(false);
//   // 🔽 ДИНАМІЧНИЙ КОНТЕНТ ІЗ FIRESTORE
//   const {
//     data: content,
//     loading: contentLoading,
//     error: contentError,
//   } = useContentDoc("siteContent", "userCabinet");
//   useEffect(() => {}, [content, contentLoading, contentError]);

//   const apiKey = "f579aac88b980dff3f819958ce1cbca6";
//   const apiUrl = "https://api.novaposhta.ua/v2.0/json/";
//   // мапа категорії профілю -> ключ ролі в контенті
//   const categoryToRoleKey = {
//     'Член "Клубу Майстрів"': "club",
//     Бібліотекар: "librarian",
//     Майстер: "maister",
//     "Бізнес-партнер": "business",
//   };
//   const businessTgUrl =
//     content?.businessTelegramUrl ?? "https://t.me/+EPPTExOea0oxYjVi";

//   // html за роллю або загальний
//   const roleKey = categoryToRoleKey[realUser?.category];
//   // const registrationRoleHtml =
//   //   (roleKey && content?.registration?.byRole?.[roleKey]) || null;
//   const registrationRoleHtml =
//     (roleKey &&
//       (content?.registration?.byRole?.[roleKey] ?? // сумісність на перехідний період: якщо ще є старе поле 'retailer'
//         (roleKey === "maister"
//           ? content?.registration?.byRole?.retailer
//           : null))) ||
//     null;
//   useEffect(() => {
//     const fetchProducts = async () => {
//       const productsRef = collection(db, "product");
//       const productsSnapshot = await getDocs(productsRef);
//       const productsList = productsSnapshot.docs.map((doc) => ({
//         id: doc.id,
//         ...doc.data(),
//       }));
//       setProducts(productsList);
//     };
//     fetchProducts();
//   }, []);

//   useEffect(() => {
//     setRealUser(userBd);
//   }, [userBd]);

//   useEffect(() => {
//     const handleScroll = () => {
//       const currentScrollHeight = window.pageYOffset;
//       setScrollHeight(currentScrollHeight);
//     };
//     window.addEventListener("scroll", handleScroll);
//     return () => window.removeEventListener("scroll", handleScroll);
//   }, []);

//   const handleLogout = () => {
//     signOut(auth)
//       .then(() => navigate("/"))
//       .catch((error) =>
//         console.log("Помилка під час виходу з системи:", error),
//       );
//   };

//   const handleBlockClick = (text) => setSelectedText(text);

//   useEffect(() => {
//     const fetchOrdersByUser = async () => {
//       if (!user) return;
//       try {
//         const ordersRef = collection(db, "orders");
//         const q = query(ordersRef, where("user", "==", user.uid));
//         const querySnapshot = await getDocs(q);

//         const parsedData = [];
//         querySnapshot.forEach((doc) => {
//           const order = { id: doc.id, ...doc.data() };
//           const choice = JSON.parse(order.choice);
//           choice.forEach((tovar) => parsedData.push({ order, tovar }));
//         });

//         let filteredData;
//         if (selectedText === 2) {
//           filteredData = parsedData.filter(
//             ({ order }) => order.status === "Очікує підтвердження",
//           );
//         } else if (selectedText === 3) {
//           filteredData =
//             JSON.parse(localStorage.getItem("likedProducts")) || [];
//         } else {
//           filteredData = parsedData.filter(
//             ({ order }) => order.status !== "Очікує підтвердження",
//           );
//         }
//         setOrders(filteredData);

//         if (selectedText !== 3) {
//           const ttnNumbers = filteredData.map(({ order }) => order.status);
//           const response = await axios.post(apiUrl, {
//             apiKey: apiKey,
//             modelName: "TrackingDocument",
//             calledMethod: "getStatusDocuments",
//             methodProperties: {
//               Documents: ttnNumbers.map((status) => ({
//                 DocumentNumber: status,
//               })),
//             },
//           });

//           const statuses = response.data.data;
//           const waitProdComponents =
//             filteredData.length > 0 ? (
//               filteredData.map(({ order, tovar }, index) => {
//                 const status =
//                   statuses.find((s) => s.Number === order.status)?.Status ||
//                   "Очікує підтвердження";
//                 return (
//                   <WaitProd
//                     key={index}
//                     el={order}
//                     tovar={tovar}
//                     status={status}
//                   />
//                 );
//               })
//             ) : (
//               <p>Актуальні замовлення відсутні.</p>
//             );
//           setWaitProdComponents(waitProdComponents);
//         } else if (selectedText === 3) {
//           const waitProdComponents = filteredData.map((tovar, index) => (
//             <WaitProdLike
//               key={index}
//               tovar={tovar}
//               setCartCounterC={setCartCounterC}
//             />
//           ));
//           setWaitProdComponents(waitProdComponents);
//         }
//       } catch (error) {
//         console.error("Помилка при отриманні замовлень:", error);
//       }
//     };

//     fetchOrdersByUser();
//   }, [user, selectedText]);

//   const onClickToElefant = () => {
//     alert(
//       "Слон дорівнює 1 грн. Слони нараховуються за ваші відгуки про наші книги. Ваші відгуки важливі, бо вони допомагають в просуванні книги в яку віримо ми і ви. Кількість слонів яка вам нараховується залежить від ціни і об'єму книги. Щоб отримати слони ви маєте розмістити відгук під книжкою яку ви раніше придбали. Слони не нараховуються автоматично за відгук, якщо ви не купували книгу на яку написали відгук на нашому сайті. Але вам можуть нарахуватись слони вручному режимі, якщо такий відгук підтвердить адміністратор сайта. Для цього ви повинні відправити лист адміністратору з посиланням на відгук.",
//     );
//   };
//   // десь поруч із іншими константами
//   const MEMBER_LABEL = 'Член "Клубу Майстрів"';

//   // після setRealUser(userBd) або нижче у блоці useEffect'ів
//   useEffect(() => {
//     if (!user || !realUser || realUser.category !== "Читач") return;

//     (async () => {
//       try {
//         // 1) спроба оновити документ напряму по uid як id
//         const directRef = doc(db, "users", user.uid);
//         await updateDoc(directRef, { category: MEMBER_LABEL });
//         setRealUser((prev) => ({ ...prev, category: MEMBER_LABEL }));
//         return;
//       } catch (_) {
//         // 2) фолбек: шукаємо за полем uid
//       }

//       try {
//         const q = query(collection(db, "users"), where("uid", "==", user.uid));
//         const snap = await getDocs(q);
//         if (snap.empty) return;
//         await Promise.all(
//           snap.docs.map((d) => updateDoc(d.ref, { category: MEMBER_LABEL })),
//         );
//         setRealUser((prev) => ({ ...prev, category: MEMBER_LABEL }));
//       } catch (err) {
//         console.error("Не вдалося оновити категорію користувача:", err);
//       }
//     })();
//   }, [user, realUser]);
//   // ✅ POPUP / EMAIL: стан і допоміжні речі
//   const [showInvite, setShowInvite] = useState(false);

//   const inviteSubject = "Запрошення до «Час майстрів»";

//   // ✅ ВІДРЕДАГОВАНИЙ ТЕКСТ ДЛЯ ДРУГА
//   const inviteText = `Привіт! Я купую дитячі книги на сайті «Час майстрів» і хочу поділитися класною штукою.
// Якщо зареєструєшся на сайті й підпишешся на їхній Telegram-канал — отримаєш додаткову знижку (разом з іншими — максимум до 40%).
// Ще там можна писати відгуки, тестувати нові книжки в опікунській раді й отримувати «Слонів» — бонуси для наступних покупок (1 Слон = 1 грн).
// Сайт: https://chas-maistriv.com.ua/
// Спробуй!`;

//   const openMailInvite = () => {
//     const href = `mailto:?subject=${encodeURIComponent(
//       inviteSubject,
//     )}&body=${encodeURIComponent(inviteText)}`;
//     window.location.href = href;
//   };

//   const copyInvite = async () => {
//     try {
//       await navigator.clipboard.writeText(inviteText);
//       alert("Текст скопійовано ✔");
//     } catch {
//       // фолбек, якщо clipboard API недоступний
//       const el = document.createElement("textarea");
//       el.value = inviteText;
//       document.body.appendChild(el);
//       el.select();
//       document.execCommand("copy");
//       document.body.removeChild(el);
//       alert("Текст скопійовано ✔");
//     }
//   };

//   // ✅ Мінімальні inline-стилі для модалки (щоб не лізти в CSS-модуль)
//   const modalStyles = {
//     overlay: {
//       position: "fixed",
//       inset: 0,
//       background: "rgba(0,0,0,.5)",
//       zIndex: 9999,
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//       padding: 16,
//     },
//     modal: {
//       background: "#fff",
//       borderRadius: 12,
//       width: "min(720px, 92vw)",
//       maxHeight: "80vh",
//       overflow: "auto",
//       padding: 24,
//       boxShadow: "0 10px 30px rgba(0,0,0,.2)",
//     },
//     h3: { margin: 0, marginBottom: 12 },
//     p: { marginTop: 0, marginBottom: 12, lineHeight: 1.5 },
//     textarea: {
//       width: "90%",
//       minHeight: 180,
//       padding: 12,
//       borderRadius: 8,
//       border: "1px solid #ddd",
//       resize: "vertical",
//       fontFamily: "inherit",
//     },
//     btnRow: { display: "flex", gap: 12, marginTop: 12, flexWrap: "wrap" },
//   };

//   const handleClickInfo = () => setInfoTg(!infoTg);
//   const changeInput = (e) => setTgId(e.target.value);
//   useEffect(() => setInfoTg(false), [workFunc]);
//   // --- BUSINESS PARTNER UI HELPERS ---
//   const isBusiness = realUser?.category === "Бізнес-партнер";

//   // знижка бізнес-партнера показується рівно така, як виставив адмін
//   // (ніяких +5% за підписку)
//   const BUSINESS_NOTE =
//     "Для категорії розпродаж застосовується стандартна знижка, для категорії акції і предпродаж застосовується акційна знижка.";

//   // --- LIBRARIAN UI HELPERS ---
//   const isLibrarian = realUser?.category === "Бібліотекар";
//   const baseDiscount = Number(realUser?.discount) || 0;
//   const isMaster = realUser?.category === "Майстер";
//   // показуємо +5% лише в відображенні (для Librarian, коли signed==="true")
//   const librarianDisplayedDiscount = isLibrarian
//     ? baseDiscount + (realUser?.signed === "true" ? 0 : 0)
//     : baseDiscount;

//   const LIBRARIAN_NOTE =
//     "Для категорії розпродаж застосовується ваша знижка, для категорії акції і предпродаж знижка не застосовується";

//   // const tgIdChange = async (uid) => {
//   //   console.log("1890910399", uid);

//   //   try {
//   //     const usersRef = collection(db, "users");
//   //     const q = query(usersRef, where("__name__", "==", uid));
//   //     const querySnapshot = await getDocs(q);
//   //     querySnapshot.forEach(async (docSnap) => {
//   //       const userRef = docSnap.ref;
//   //       await updateDoc(userRef, { telegramId: tgId });
//   //     });
//   //     setWorkFunc(!workFunc);
//   //     // window.location.reload();
//   //   } catch (error) {
//   //     console.error("Помилка при оновленні значення telegramId:", error);
//   //   }
//   // };
//   const tgIdChange = async (uid) => {
//     const tgIdValue = String(tgId || "").trim(); // беремо зі стейту

//     console.log("tgIdValue", tgIdValue);
//     console.log("uid", uid);

//     if (!uid || !tgIdValue) {
//       console.error("uid або tgId відсутні", { uid, tgId: tgIdValue });
//       return;
//     }

//     try {
//       const directRef = doc(db, "users", uid);
//       await updateDoc(directRef, { telegramId: tgIdValue });
//       window.location.reload(); // лише після успіху
//       return;
//     } catch (_) {
//       // фолбек, якщо id документа інший
//     }

//     try {
//       const q = query(collection(db, "users"), where("uid", "==", uid));
//       const snap = await getDocs(q);
//       if (snap.empty) throw new Error("Користувача з таким uid не знайдено.");
//       await Promise.all(
//         snap.docs.map((d) => updateDoc(d.ref, { telegramId: tgIdValue })),
//       );
//       window.location.reload(); // лише після успішного запису
//     } catch (err) {
//       console.error("Помилка при оновленні telegramId:", err);
//     }
//   };
//   // const openSet = () => setCheSetinings(!cheSetinings);
//   const openSet = () => navigate(`/user/${user?.uid}`);

//   const cabinetOptions = [
//     { label: 'Член "Клубу Майстрів"', key: "club" },
//     { label: "Бібліотекар", key: "librarian" },
//     { label: "Майстер", key: "maister" },
//     { label: "Бізнес-партнер", key: "business" },
//   ];
//   // лінки на Google-форми (можна перезаписати з Firestore: siteContent/userCabinet/forms.*)
//   // const cabinetForms = {
//   //   librarian:
//   //     content?.forms?.librarian ?? "https://forms.gle/your-librarian-form",
//   //   retailer:
//   //     content?.forms?.retailer ?? "https://forms.gle/your-retailer-form",
//   //   business:
//   //     content?.forms?.business ?? "https://forms.gle/your-business-form",
//   // };
//   // const cabinetForms = {
//   //   librarian:
//   //     content?.forms?.librarian ?? "https://forms.gle/your-librarian-form",
//   //   maister:
//   //     content?.forms?.maister ??
//   //     // сумісність: якщо ще не створив maister у Firestore
//   //     content?.forms?.retailer ??
//   //     "https://forms.gle/your-master-form",
//   //   business:
//   //     content?.forms?.business ?? "https://forms.gle/your-business-form",
//   // };
//   // скільки днів минуло після подачі заявки
//   const daysSinceRequest = useMemo(() => {
//     if (!cabinetRequest?.ts) return null;
//     return Math.floor((Date.now() - cabinetRequest.ts) / (1000 * 60 * 60 * 24));
//   }, [cabinetRequest]);

//   // Фолбеки на випадок, якщо документ ще не створено в Firestore
//   const heroMission =
//     content?.hero?.missionText ??
//     "Наша місія — допомогти батькам ростити дітей людьми, які вміють бути щасливими";
//   const heroGoal =
//     content?.hero?.goalText ??
//     "Наша мета — створювати якісні дитячі книги, від яких важко відірватися, та які збагачують.";
//   const tabs = content?.blocks ?? [
//     { id: 1, title: "Статус замовлення" },
//     { id: 2, title: "Чекають опрацювання" },
//     { id: 3, title: "Бажане" },
//   ];

//   const facebookUrl =
//     content?.socialLinks?.facebookUrl ??
//     "https://www.facebook.com/chasmaistriv";
//   const emailLink = content?.socialLinks?.email ?? "sales@chasmaistriv.com.ua";
//   const telegramUrl =
//     content?.socialLinks?.telegramUrl ?? "https://t.me/chas_maistriv";
//   const viberUrl =
//     content?.socialLinks?.viberUrl ??
//     "https://invite.viber.com/?g2=AQBidB45Be8Vo057AydEGn81babrL0jatg7TIhXEIJeF4eMeFK1Qr4RQChEzk%2Fix";

//   const unsigned = content?.discount?.unsigned;
//   const signed = content?.discount?.signed;
//   const handleCabinetSelect = (opt) => {
//     setShowCabinetMenu(false);

//     if (opt.key === "club") {
//       alert(
//         "Кабінет «Член клубу Майстрів» доступний без анкети. Якщо ви ще не в ньому — ми додамо вас автоматично.",
//       );
//       return;
//     }

//     const url = cabinetForms[opt.key];
//     if (url) window.open(url, "_blank", "noopener,noreferrer");

//     const req = { type: opt.label, key: opt.key, ts: Date.now() };
//     localStorage.setItem("cabinetRequest", JSON.stringify(req));
//     setCabinetRequest(req);

//     alert(`Після заповнення форми ваш кабінет буде змінено після перевірки адміністратором. Ми повідомимо про це на e-mail.
// Якщо протягом тижня змін не буде — напишіть адміну: ${emailLink}`);
//   };

//   const menuStyles = {
//     wrap: { position: "relative", display: "inline-block", marginLeft: 8 },
//     btn: {
//       border: "1px solid #3e51c1",
//       background: "#3e51c1",
//       color: "#fff",
//       padding: "8px 12px",
//       cursor: "pointer",
//       fontSize: 19,
//       lineHeight: 1,
//       borderRadius: 0,
//     },
//     menu: {
//       position: "absolute",
//       top: "110%",
//       right: 0,
//       minWidth: 260,
//       background: "#fff",
//       border: "1px solid #e5e5e5",
//       boxShadow: "0 10px 20px rgba(0,0,0,.08)",
//       borderRadius: 8,
//       zIndex: 50,
//       overflow: "hidden",
//     },
//     item: {
//       padding: "10px 12px",
//       cursor: "pointer",
//       borderBottom: "1px solid #f1f1f1",
//       userSelect: "none",
//     },
//     itemLast: { borderBottom: "none" },
//     note: {
//       marginTop: 10,
//       background: "#fff8e1",
//       border: "1px solid #ffe08a",
//       padding: "8px 12px",
//       borderRadius: 8,
//       fontSize: 14,
//       lineHeight: 1.4,
//     },
//   };
//   // відповідність ключа форми -> назва категорії в профілі
//   // const cabinetKeyToCategory = {
//   //   club: 'Член "Клубу Майстрів"',
//   //   librarian: "Бібліотекар",
//   //   retailer: "Продавець книг в книгарні",
//   //   business: "Бізнес-партнер",
//   // };
//   const cabinetKeyToCategory = {
//     club: 'Член "Клубу Майстрів"',
//     librarian: "Бібліотекар",
//     maister: "Майстер",
//     business: "Бізнес-партнер",
//   };
//   useEffect(() => {
//     if (cabinetRequest?.key === "retailer") {
//       const migrated = { ...cabinetRequest, key: "maister", type: "Майстер" };
//       localStorage.setItem("cabinetRequest", JSON.stringify(migrated));
//       setCabinetRequest(migrated);
//     }
//   }, [cabinetRequest]);
//   // якщо адміністратор вже змінив категорію — прибираємо локальний прапорець
//   useEffect(() => {
//     if (!realUser || !cabinetRequest) return;
//     const expected = cabinetKeyToCategory[cabinetRequest.key];
//     if (expected && realUser.category === expected) {
//       localStorage.removeItem("cabinetRequest");
//       setCabinetRequest(null);
//     }
//   }, [realUser, cabinetRequest]);
//   useEffect(() => {
//     if (!realUser || !cabinetRequest) return;

//     // якщо роль користувача вже відповідає тій, на яку він подавав заявку –
//     // прибираємо прапорець і банер
//     if (realUser.category === cabinetRequest.type) {
//       localStorage.removeItem("cabinetRequest");
//       setCabinetRequest(null);
//     }
//   }, [realUser?.category, cabinetRequest]);

//   return (
//     <>
//       {realUser && (
//         <div>
//           <div className={css.bleuLabel}>
//             <div className={css.blueLabelWnutr}>
//               <p className={css.firstTextInBlock}>{heroMission}</p>
//               <p className={css.firstTextInBlock}>{heroGoal}</p>
//             </div>
//           </div>
//           {realUser && (
//             <div className={css.userInformationWrap}>
//               <div className={css.userInformationWrapSmall}>
//                 <div className={css.yourInformation}>
//                   <div className={css.userData}>
//                     <div className={css.imgAutorWrapSmall}>
//                       {realUser.photo ? (
//                         <img
//                           src={realUser.photo}
//                           className={css.imgAutorSmall}
//                         />
//                       ) : (
//                         <img src={que} className={css.imgAutorSmall} />
//                       )}
//                     </div>
//                     <div className={css.nameAndPropWr}>
//                       {realUser.displayName ? (
//                         <h4 className={css.userNameHello}>
//                           {realUser.displayName}, вітаємо!
//                         </h4>
//                       ) : (
//                         <h4 className={css.userNameHello}>
//                           Користувач, вітаємо!
//                         </h4>
//                       )}
//                       <div className={css.propWrap}>
//                         <div className={css.newdso}>
//                           <img src={iconProp} />
//                           <p className={css.propP} onClick={openSet}>
//                             Налаштування
//                           </p>
//                         </div>
//                         <UserChatBadge
//                           uid={user?.uid}
//                           onOpen={() => setOpenChat(true)}
//                         />
//                         <h2 className={css.outButton} onClick={handleLogout}>
//                           Вийти з кабінету
//                         </h2>
//                       </div>
//                       {cheSetinings && (
//                         <ChangeData
//                           scrollHeight={scrollHeight}
//                           realUser={realUser}
//                           setCheSetinings={setCheSetinings}
//                           setRealUser={setRealUser}
//                         />
//                       )}
//                     </div>
//                   </div>
//                   {windowDimensions ? (
//                     <img src={Group16} className={css.iconPicBird} />
//                   ) : (
//                     <img src={Group17} className={css.iconPicBird} />
//                   )}
//                 </div>
//                 <div className={css.ourInformation}>
//                   {/* <h4 className={css.yourRegistration}>
//                     {content?.registration?.prefix ?? "Ви зареєстровані як"}{" "}
//                     {realUser.category}
//                   </h4> */}
//                   <h4
//                     className={css.yourRegistration}
//                     style={{ display: "flex", alignItems: "center", gap: 8 }}
//                   >
//                     {content?.registration?.prefix ?? "Ви зареєстровані як"}{" "}
//                     {realUser.category}
//                     <span style={menuStyles.wrap}>
//                       <button
//                         type="button"
//                         className={css.likeButton}
//                         style={menuStyles.btn} // без заокруглень і без ховера
//                         onClick={() => setShowCabinetMenu((v) => !v)}
//                       >
//                         Змінити кабінет
//                       </button>

//                       {showCabinetMenu && (
//                         <div style={menuStyles.menu}>
//                           {cabinetOptions.map((opt, idx) => (
//                             <div
//                               key={opt.key}
//                               style={{
//                                 ...menuStyles.item,
//                                 ...(idx === cabinetOptions.length - 1
//                                   ? menuStyles.itemLast
//                                   : null),
//                               }}
//                               onClick={() => handleCabinetSelect(opt)}
//                               onKeyDown={(e) =>
//                                 e.key === "Enter" && handleCabinetSelect(opt)
//                               }
//                               role="button"
//                               tabIndex={0}
//                             >
//                               {opt.label}
//                             </div>
//                           ))}
//                         </div>
//                       )}
//                     </span>
//                   </h4>

//                   {registrationRoleHtml ? (
//                     <div
//                       className={css.yourDescription}
//                       dangerouslySetInnerHTML={{ __html: registrationRoleHtml }}
//                     />
//                   ) : content?.registration?.descriptionHtml ? (
//                     <div
//                       className={css.yourDescription}
//                       dangerouslySetInnerHTML={{
//                         __html: content.registration.descriptionHtml,
//                       }}
//                     />
//                   ) : (
//                     <p className={css.yourDescription}>
//                       Це дає вам знижки та доступ до коментів, а також ви
//                       потрапляєте під роздачу слонів (бонусів), можете брати
//                       участь в опікунських радах і тестуванні книг, впливати на
//                       вибір обкладинок, назв текстів та обговорювати злободенні
//                       питання. Якщо ви довіряєте нам як спеціалістам у виборі та
//                       створенні дитячої книги, запрошуємо вас встановити з нами
//                       прямий контакт через імейл, вайбер, телеграм, або вотсап.
//                       Приєднуйтесь до спільноти поціновувачів книжок,
//                       підписавшись на наші соцмережі. Настав Час майстрів.
//                     </p>
//                   )}

//                   {cabinetRequest && (
//                     <div style={menuStyles.note}>
//                       Ви подали заявку на перехід у кабінет:{" "}
//                       <b>{cabinetRequest.type}</b>. Після опрацювання анкети
//                       адміністратор змінить ваш кабінет і повідомить про це на
//                       e-mail.
//                       {typeof daysSinceRequest === "number" &&
//                       daysSinceRequest >= 7 ? (
//                         <>
//                           {" "}
//                           Минув тиждень? Напишіть адміну:{" "}
//                           <a href={`mailto:${emailLink}`}>{emailLink}</a>.
//                         </>
//                       ) : (
//                         <>
//                           {" "}
//                           Якщо протягом тижня зміни не відбудуться — напишіть
//                           адміну:{" "}
//                           <a href={`mailto:${emailLink}`}>{emailLink}</a>.
//                         </>
//                       )}
//                     </div>
//                   )}

//                   <div className={css.socialWrap}>
//                     <a
//                       href={facebookUrl}
//                       target="_blank"
//                       rel="noreferrer noopener"
//                     >
//                       <div className={css.standartsocial}>
//                         <img src={facForUs} />
//                       </div>
//                     </a>
//                     <a
//                       href={`mailto:${emailLink}`}
//                       target="_blank"
//                       rel="noreferrer noopener"
//                     >
//                       <div className={css.standartsocial}>
//                         <img src={mailForSoc} />
//                       </div>
//                     </a>
//                     <a
//                       href={telegramUrl}
//                       target="_blank"
//                       rel="noreferrer noopener"
//                     >
//                       <div className={css.standartsocial}>
//                         <img src={tgUser} />
//                       </div>
//                     </a>
//                     <a
//                       href={viberUrl}
//                       target="_blank"
//                       rel="noreferrer noopener"
//                     >
//                       <div className={css.standartsocial}>
//                         <img src={whatUser} />
//                       </div>
//                     </a>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           )}
//           {/* <div className={css.orderingProductWrap}>
//             <div className={css.orderingProductWrapSmall}>
//               <div className={css.wrapLab}>
//                 {tabs.map((block) => (
//                   <div
//                     key={block.id}
//                     className={`${css.block} ${
//                       block.id === selectedText ? css.selected : ""
//                     }`}
//                     onClick={() => handleBlockClick(block.id)}
//                   >
//                     {block.title}
//                   </div>
//                 ))}
//               </div>

//               {waitProdComponents.length > 0 ? (
//                 <div className={css.waitOrderInPostWrap}>
//                   {waitProdComponents}
//                 </div>
//               ) : (
//                 <p></p>
//               )}
//             </div>
//           </div> */}
//           {realUser?.category !== "Бізнес-партнер" && (
//             <div className={css.orderingProductWrap}>
//               <div className={css.orderingProductWrapSmall}>
//                 <div className={css.wrapLab}>
//                   {tabs.map((block) => (
//                     <div
//                       key={block.id}
//                       className={`${css.block} ${
//                         block.id === selectedText ? css.selected : ""
//                       }`}
//                       onClick={() => handleBlockClick(block.id)}
//                     >
//                       {block.title}
//                     </div>
//                   ))}
//                 </div>

//                 {waitProdComponents.length > 0 ? (
//                   <div className={css.waitOrderInPostWrap}>
//                     {waitProdComponents}
//                   </div>
//                 ) : (
//                   <p></p>
//                 )}
//               </div>
//             </div>
//           )}
//           {realUser?.category === "Бізнес-партнер" && (
//             <BusinessPartnerOrders user={user} />
//           )}
//           {realUser && realUser.signed === "false" && (
//             <>
//               {isLibrarian ? (
//                 /* ----------- ЛІБРАРІАН: НЕ ПІДПИСАНИЙ ----------- */
//                 <>
//                   <div className={css.yourDiscountWrap}>
//                     <div className={css.yourDiscountWrapSmall}>
//                       <div className={css.dicsTextWr}>
//                         <p className={css.yourDicrFive}>
//                           Знижка бібліотекаря
//                           <br />
//                           <span className={css.yourDicrFiveSpan}>
//                             {baseDiscount}%
//                           </span>
//                         </p>

//                         <p className={css.yourDicrFiveSmall}>
//                           Підпишіться на наш Telegram-канал — отримаєте
//                           додатково +5% до вашої знижки.
//                         </p>

//                         <p
//                           className={css.yourDicrFiveSmall}
//                           style={{ marginTop: 8 }}
//                         >
//                           {LIBRARIAN_NOTE}
//                         </p>
//                       </div>

//                       <img src={discIcon} className={css.discIconIc} />

//                       <div className={css.buttonConfFRW}>
//                         <p className={css.confirmP}>Детальніше</p>
//                         <div
//                           className={css.likeButton}
//                           onClick={handleClickInfo}
//                         >
//                           Інформація
//                         </div>
//                       </div>
//                     </div>
//                   </div>

//                   {infoTg && (
//                     <div className={css.yourDiscountWrapInfo}>
//                       <div className={css.yourDiscountWrapSmall}>
//                         <div className={css.dicsTextWrInfo}>
//                           <p className={css.yourDicrFive}>
//                             {unsigned?.stepsTitle ??
//                               "Для успішного отримання додаткової знижки зробіть наступні кроки:"}
//                           </p>
//                           <ol
//                             className={css.yourDicrFiveSmall}
//                             style={{ paddingLeft: 16 }}
//                           >
//                             {(unsigned?.steps ?? []).map((s, i) => (
//                               <li key={i} style={{ marginBottom: 8 }}>
//                                 {s}
//                               </li>
//                             ))}
//                           </ol>
//                         </div>

//                         <div className={css.buttonConfFRW}>
//                           <a
//                             className={css.likeButton}
//                             href={
//                               unsigned?.getIdBotUrl ?? "https://t.me/getidsbot"
//                             }
//                             target="_blank"
//                             rel="noreferrer noopener"
//                           >
//                             <div className={css.likeButton}>Отримати ID</div>
//                           </a>

//                           <input
//                             className={css.inputTgId}
//                             value={tgId}
//                             placeholder="Ваш телеграм ID"
//                             onChange={(e) => setTgId(e.target.value)}
//                           />

//                           <a
//                             className={css.likeButton}
//                             href={
//                               unsigned?.channelUrl ??
//                               "https://t.me/chas_maistriv"
//                             }
//                             target="_blank"
//                             rel="noreferrer noopener"
//                           >
//                             <div
//                               className={css.likeButton}
//                               onClick={() => tgIdChange(user.uid)}
//                             >
//                               Підписатись
//                             </div>
//                           </a>
//                         </div>
//                       </div>
//                     </div>
//                   )}
//                 </>
//               ) : isBusiness ? (
//                 /* ----------- БІЗНЕС-ПАРТНЕР: НЕ ПІДПИСАНИЙ ----------- */
//                 <div className={css.yourDiscountWrap}>
//                   <div className={css.yourDiscountWrapSmall}>
//                     <div className={css.dicsTextWr}>
//                       <p className={css.yourDicrFive}>
//                         Знижка бізнес-партнера
//                         <br />
//                         <span className={css.yourDicrFiveSpan}>
//                           {baseDiscount}%
//                         </span>
//                       </p>

//                       {/* без жодних підписок/додаткових 5% */}
//                       <p className={css.yourDicrFiveSmall}>{BUSINESS_NOTE}</p>
//                     </div>

//                     <img src={discIcon} className={css.discIconIc} />

//                     {/* Порожній правий блок (без "Інформація"/"Підписатись") */}
//                     <div className={css.buttonConfFRW}>
//                       <p
//                         className={css.confirmP}
//                         style={{
//                           background: "#2e7d32",
//                           color: "#fff",
//                           padding: "8px 12px",
//                           borderRadius: 8,
//                           marginBottom: 8,
//                           display: "inline-block",
//                         }}
//                       >
//                         Телеграм-канал для бізнес партнерів
//                       </p>

//                       <a
//                         href={businessTgUrl}
//                         target="_blank"
//                         rel="noreferrer noopener"
//                         className={css.likeButton}
//                         style={{
//                           background: "#ffd54f",
//                           color: "#000",
//                           borderRadius: 8,
//                           display: "inline-block",
//                           textDecoration: "none",
//                         }}
//                       >
//                         ПІДПИСАТИСЯ
//                       </a>
//                     </div>
//                   </div>
//                 </div>
//               ) : (
//                 /* ----------- ІНШІ КАТЕГОРІЇ: як було ----------- */
//                 <>
//                   <div className={css.yourDiscountWrap}>
//                     <div className={css.yourDiscountWrapSmall}>
//                       <div className={css.dicsTextWr}>
//                         <p className={css.yourDicrFive}>
//                           {unsigned?.title ?? "Ваша знижка*"}
//                           <br />
//                           <span className={css.yourDicrFiveSpan}>
//                             {realUser.discount}%
//                           </span>
//                         </p>
//                         <p className={css.yourDicrFiveSmall}>
//                           {unsigned?.subtitle ??
//                             "Для отримання знижки 5% підпишіться на наш телеграм канал"}
//                         </p>
//                       </div>
//                       <img src={discIcon} className={css.discIconIc} />
//                       <div className={css.buttonConfFRW}>
//                         <p className={css.confirmP}>Детальніше</p>
//                         <div
//                           className={css.likeButton}
//                           onClick={handleClickInfo}
//                         >
//                           Інформація
//                         </div>
//                       </div>
//                     </div>
//                   </div>

//                   {infoTg && (
//                     <div className={css.yourDiscountWrapInfo}>
//                       <div className={css.yourDiscountWrapSmall}>
//                         <div className={css.dicsTextWrInfo}>
//                           <p className={css.yourDicrFive}>
//                             {unsigned?.stepsTitle ??
//                               "Для успішного отримання знижки вам потрібно зробити наступні кроки:"}
//                           </p>
//                           <ol
//                             className={css.yourDicrFiveSmall}
//                             style={{ paddingLeft: 16 }}
//                           >
//                             {(unsigned?.steps ?? []).map((s, i) => (
//                               <li key={i} style={{ marginBottom: 8 }}>
//                                 {s}
//                               </li>
//                             ))}
//                           </ol>
//                         </div>

//                         <div className={css.buttonConfFRW}>
//                           <a
//                             className={css.likeButton}
//                             href={
//                               unsigned?.getIdBotUrl ?? "https://t.me/getidsbot"
//                             }
//                             target="_blank"
//                             rel="noreferrer noopener"
//                           >
//                             <div className={css.likeButton}>Отримати ID</div>
//                           </a>
//                           <input
//                             className={css.inputTgId}
//                             value={tgId}
//                             placeholder="Ваш телеграм ID"
//                             onChange={(e) => setTgId(e.target.value)}
//                           />
//                           <a
//                             className={css.likeButton}
//                             href={
//                               unsigned?.channelUrl ??
//                               "https://t.me/chas_maistriv"
//                             }
//                             target="_blank"
//                             rel="noreferrer noopener"
//                           >
//                             <div
//                               className={css.likeButton}
//                               onClick={() => tgIdChange(user.uid)}
//                             >
//                               Підписатись
//                             </div>
//                           </a>
//                         </div>
//                       </div>
//                     </div>
//                   )}
//                 </>
//               )}
//             </>
//           )}
//           {realUser && realUser.signed === "true" && (
//             <>
//               {isLibrarian ? (
//                 /* ----------- ЛІБРАРІАН: ПІДПИСАНИЙ ----------- */
//                 <div className={css.yourDiscountWrap}>
//                   <div className={css.yourDiscountWrapSmall}>
//                     <div className={css.dicsTextWr}>
//                       <p className={css.yourDicrFive}>
//                         Знижка бібліотекаря
//                         <br />
//                         <span className={css.yourDicrFiveSpan}>
//                           {librarianDisplayedDiscount}%
//                         </span>
//                       </p>
//                       <p className={css.yourDicrFiveSmall}>
//                         До вашої базової знижки {baseDiscount - 5}% автоматично
//                         додано +5% за підписку на Telegram.
//                       </p>
//                       <p
//                         className={css.yourDicrFiveSmall}
//                         style={{ marginTop: 8 }}
//                       >
//                         {LIBRARIAN_NOTE}
//                       </p>
//                     </div>

//                     <img src={discIcon} className={css.discIconIc} />

//                     <div className={css.buttonConfFRW}>
//                       <p className={css.confirmP}>Запросити колегу</p>
//                       <button
//                         type="button"
//                         className={`${css.likeButton} ${css.inviteBtn} ${css.noRadius}`}
//                         onClick={() => setShowInvite(true)}
//                       >
//                         Запросити колегу
//                       </button>
//                     </div>
//                   </div>

//                   {showInvite && (
//                     <div
//                       style={modalStyles.overlay}
//                       onClick={() => setShowInvite(false)}
//                     >
//                       <div
//                         style={modalStyles.modal}
//                         onClick={(e) => e.stopPropagation()}
//                       >
//                         <h3 style={modalStyles.h3}>Запросити колегу</h3>
//                         <p style={modalStyles.p}>
//                           Просимо підтримати «Час майстрів». Скопіюйте текст
//                           нижче або надішліть його одразу через пошту.
//                         </p>
//                         <textarea
//                           readOnly
//                           style={modalStyles.textarea}
//                           value={inviteText}
//                         />
//                         <div style={modalStyles.btnRow}>
//                           <button
//                             type="button"
//                             className={`${css.likeButton} ${css.inviteBtn} ${css.noRadius}`}
//                             onClick={copyInvite}
//                           >
//                             Скопіювати
//                           </button>
//                           <button
//                             type="button"
//                             className={`${css.likeButton} ${css.inviteBtn} ${css.noRadius}`}
//                             onClick={openMailInvite}
//                           >
//                             Відкрити e-mail
//                           </button>
//                           <button
//                             type="button"
//                             className={`${css.likeButton} ${css.inviteBtn} ${css.noRadius}`}
//                             onClick={() => setShowInvite(false)}
//                           >
//                             Закрити
//                           </button>
//                         </div>
//                       </div>
//                     </div>
//                   )}
//                 </div>
//               ) : isBusiness ? (
//                 /* ----------- БІЗНЕС-ПАРТНЕР: ПІДПИСАНИЙ ----------- */
//                 <div className={css.yourDiscountWrap}>
//                   <div className={css.yourDiscountWrapSmall}>
//                     <div className={css.dicsTextWr}>
//                       <p className={css.yourDicrFive}>
//                         Знижка бізнес-партнера
//                         <br />
//                         <span className={css.yourDicrFiveSpan}>
//                           {baseDiscount}%
//                         </span>
//                       </p>
//                       {/* жодного +5% за підписку */}
//                       <p className={css.yourDicrFiveSmall}>{BUSINESS_NOTE}</p>
//                     </div>

//                     <img src={discIcon} className={css.discIconIc} />

//                     {/* за бажанням можна лишити запрошення друга; якщо не потрібно — залиш так */}
//                     <div className={css.buttonConfFRW}>
//                       <p
//                         className={css.confirmP}
//                         style={{
//                           color: "#fff",
//                           padding: "8px 12px",
//                           borderRadius: 8,
//                           marginBottom: 8,
//                           display: "inline-block",
//                         }}
//                       >
//                         Телеграм-канал для бізнес партнерів
//                       </p>

//                       <a
//                         href={businessTgUrl}
//                         target="_blank"
//                         rel="noreferrer noopener"
//                         className={css.likeButton}
//                       >
//                         ПІДПИСАТИСЯ
//                       </a>
//                     </div>
//                   </div>
//                 </div>
//               ) : (
//                 /* ----------- ІНШІ КАТЕГОРІЇ: як було ----------- */
//                 <div className={css.yourDiscountWrap}>
//                   <div className={css.yourDiscountWrapSmall}>
//                     <div className={css.dicsTextWr}>
//                       <p className={css.yourDicrFive}>
//                         {signed?.noteTitle ?? "Ваша знижка*"}
//                         <br />
//                         <span className={css.yourDicrFiveSpan}>
//                           {realUser.discount}%
//                         </span>
//                       </p>
//                       <p className={css.yourDicrFiveSmall}>
//                         {signed?.note ??
//                           "До знижки не додаються акції, розпродаж, предпродаж"}
//                       </p>
//                     </div>

//                     <img src={discIcon} className={css.discIconIc} />

//                     <div className={css.buttonConfFRW}>
//                       {isMaster ? (
//                         <>
//                           <p className={css.confirmP}>Запросити колегу</p>
//                           <button
//                             type="button"
//                             className={`${css.likeButton} ${css.inviteBtn} ${css.noRadius}`}
//                             onClick={() => setShowInvite(true)}
//                           >
//                             Запросити колегу
//                           </button>
//                         </>
//                       ) : (
//                         <>
//                           <p className={css.confirmP}>Запросити друга</p>
//                           <button
//                             type="button"
//                             className={`${css.likeButton} ${css.inviteBtn} ${css.noRadius}`}
//                             onClick={() => setShowInvite(true)}
//                           >
//                             {signed?.inviteCta ?? "Запросити"}
//                           </button>
//                         </>
//                       )}
//                     </div>
//                   </div>

//                   {showInvite && (
//                     <div
//                       style={modalStyles.overlay}
//                       onClick={() => setShowInvite(false)}
//                     >
//                       <div
//                         style={modalStyles.modal}
//                         onClick={(e) => e.stopPropagation()}
//                       >
//                         <h3 style={modalStyles.h3}>Запросити друга</h3>
//                         <p style={modalStyles.p}>
//                           Просимо підтримати «Час майстрів». Скопіюйте текст
//                           нижче або надішліть його одразу через пошту.
//                         </p>
//                         <textarea
//                           readOnly
//                           style={modalStyles.textarea}
//                           value={inviteText}
//                         />
//                         <div style={modalStyles.btnRow}>
//                           <button
//                             type="button"
//                             className={`${css.likeButton} ${css.inviteBtn} ${css.noRadius}`}
//                             onClick={copyInvite}
//                           >
//                             Скопіювати
//                           </button>
//                           <button
//                             type="button"
//                             className={`${css.likeButton} ${css.inviteBtn} ${css.noRadius}`}
//                             onClick={openMailInvite}
//                           >
//                             Відкрити e-mail
//                           </button>
//                           <button
//                             type="button"
//                             className={`${css.likeButton} ${css.inviteBtn} ${css.noRadius}`}
//                             onClick={() => setShowInvite(false)}
//                           >
//                             Закрити
//                           </button>
//                         </div>
//                       </div>
//                     </div>
//                   )}
//                 </div>
//               )}
//             </>
//           )}
//           {realUser.category === "Бібліотекар" && <LibraryOffersBanner />}
//           {realUser.category === "Бібліотекар" && <LibraryCatalogBanner />}
//           {realUser.category === "Бізнес-партнер" && (
//             <CommercialNewsBanner />
//           )}{" "}
//           {realUser.category === "Бізнес-партнер" && <CabinetTilesDynamiс />}{" "}
//           {realUser.category === "Бізнес-партнер" && <BusinessInvoices />}
//           {realUser.category === 'Член "Клубу Майстрів"' && <BlockReader />}
//           {/* {realUser.category === "Читач" && <BlockReader />} */}
//           {realUser.category === "Бізнес-партнер" && (
//             <BlockBusiness userBd={realUser} />
//           )}
//           {realUser.category === "Бібліотекар" && <BlockLibrarian />}
//           {realUser.category === "Майстер" && (
//             <BlockMaister userBd={realUser} />
//           )}
//           {realUser.category === 'Член "Клубу Майстрів"' && (
//             <div className={css.elefantWrap} onClick={onClickToElefant}>
//               <div className={css.elefantWrapSmall}>
//                 <div className={css.elef}>
//                   <img src={elefant} className={css.elefant} />
//                   <p className={css.howMathElefant}>
//                     Ваші слони <br />
//                     <span className={css.howMathElefantSpan}>
//                       {realUser.elefant}
//                     </span>
//                   </p>
//                 </div>
//                 <p className={css.elefantDescription}>
//                   <span
//                     dangerouslySetInnerHTML={{
//                       __html:
//                         content?.elephants?.leadHtml ??
//                         "Ви можете <br /> сплачувати слонами <br /> за наші книги",
//                     }}
//                   />
//                   {content?.elephants?.infoReader ? (
//                     <span className={css.elefantDescriptionSpan}>
//                       {content.elephants.infoReader}
//                     </span>
//                   ) : (
//                     <span className={css.elefantDescriptionSpan}>
//                       1 Слон = 1 Грн
//                     </span>
//                   )}
//                 </p>
//               </div>
//             </div>
//           )}
//           <ViewProductCatalog
//             products={products}
//             setCartCounterC={setCartCounterC}
//             setLikeCounterC={setLikeCounterC}
//           />
//           {openChat && (
//             <UserChat uid={user?.uid} onClose={() => setOpenChat(false)} />
//           )}
//         </div>
//       )}
//     </>
//   );
// };
// export default withUserData(UserCabinet);

import css from "./userCabinet.module.css";
import {
  collection,
  query,
  where,
  getDocs,
  updateDoc,
  getDoc,
  doc,
  onSnapshot,
  serverTimestamp,
} from "firebase/firestore";
import BusinessPartnerOrders from "./BusinessPartnerOrders";
import UserOrders from "./UserOrders";
import iconProp from "../../img/iconProp.png";
import Group16 from "../../img/Group16.png";
import Group17 from "../../img/smallGroup.png";
import facForUs from "../../img/facForUs.png";
import mailForSoc from "../../img/mailForSoc.png";
import tgUser from "../../img/tgUser.png";
import whatUser from "../../img/whatUser.png";
import { useState, useEffect, useMemo } from "react";
import WaitProd from "./waitProd";
import discIcon from "../../img/discIcon.png";
import { Link, useNavigate } from "react-router-dom";
import { auth, db } from "../../firebase";
import axios from "axios";
import withUserData from "../HOK/withUserData";
import { signOut } from "firebase/auth";
import elefant from "../../img/elefant.png";
import ViewProductCatalog from "../catalog/viewProductCatalog";
import WaitProdLike from "./waitProdLike";
import que from "../../img/que.png";
import BlockReader from "./blockReader";
import BlockMaister from "./blockMaister";
import BlockBusiness from "./blockBusiness";
import ChangeData from "./changeData";
import UserChat from "../chat/UserChat";
import UserChatBadge from "../chat/UserChatBadge";
import CommercialNewsBanner from "../admin/main/CommercialNewsBanner";
import BusinessInvoices from "./BusinessInvoices.jsx";
import CabinetTilesDynamiс from "./CabinetTilesDynamic.jsx";
import BlockLibrarian from "./BlockLibrarian.jsx";
import LibraryOffersBanner from "./LibraryOffersBanner.jsx";
import LibraryCatalogBanner from "./LibraryCatalogBanner.jsx";
import RoleChangeFormModal from "./RoleChangeFormModal.jsx";
const UserCabinet = ({
  setAddressChanged,
  addressChanged,
  windowDimensions,
  user,
  userBd,
  setCartCounterC,
  visitedProducts,
  setLikeCounterC,
}) => {
  const t = useCabinetText("cabinet");
  const navigate = useNavigate();
  const [selectedText, setSelectedText] = useState(1);
  const [scrollHeight, setScrollHeight] = useState(0);
  const [infoTg, setInfoTg] = useState(false);
  const [tgId, setTgId] = useState("");
  const [products, setProducts] = useState([]);
  const [realUser, setRealUser] = useState(null);
  const [orders, setOrders] = useState([]);
  const [workFunc, setWorkFunc] = useState(false);
  const [openChat, setOpenChat] = useState(false);
  const [cheSetinings, setCheSetinings] = useState(false);
  const [waitProdComponents, setWaitProdComponents] = useState([]);
  const [showCabinetMenu, setShowCabinetMenu] = useState(false);
  const [latestRoleRequest, setLatestRoleRequest] = useState(null);
  const [acknowledgingRejection, setAcknowledgingRejection] = useState(false);
  const [cabinetRequest, setCabinetRequest] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("cabinetRequest")) || null;
    } catch {
      return null;
    }
  });
  const [selectedCabinetRole, setSelectedCabinetRole] = useState(null);
  const [showRoleFormModal, setShowRoleFormModal] = useState(false);
  // 🔽 ДИНАМІЧНИЙ КОНТЕНТ ІЗ FIRESTORE
  const {
    data: content,
    loading: contentLoading,
    error: contentError,
  } = useCabinetContent();
  useEffect(() => {}, [content, contentLoading, contentError]);

  const apiKey = "f579aac88b980dff3f819958ce1cbca6";
  const apiUrl = "https://api.novaposhta.ua/v2.0/json/";
  // мапа категорії профілю -> ключ ролі в контенті
  const categoryToRoleKey = {
    'Член "Клубу Майстрів"': "club",
    Бібліотекар: "librarian",
    Майстер: "maister",
    "Бізнес-партнер": "business",
  };
  const businessTgUrl =
    content?.businessTelegramUrl ?? "https://t.me/+EPPTExOea0oxYjVi";

  // html за роллю або загальний
  const roleKey = categoryToRoleKey[realUser?.category];
  // const registrationRoleHtml =
  //   (roleKey && content?.registration?.byRole?.[roleKey]) || null;
  const registrationRoleHtml =
    roleKey && !content?.registration?.useShared?.[roleKey] ? content?.registration?.byRole?.[roleKey] ?? "" : content?.registration?.descriptionHtml ?? "";
  useEffect(() => {
    if (!user?.uid) {
      setLatestRoleRequest(null);
      return;
    }

    const requestsQuery = query(
      collection(db, "roleChangeRequests"),
      where("userId", "==", user.uid),
    );

    const unsubscribe = onSnapshot(
      requestsQuery,
      (snapshot) => {
        const requests = snapshot.docs.map((requestDoc) => ({
          id: requestDoc.id,
          ...requestDoc.data(),
        }));

        const getTimestamp = (request) => {
          const value =
            request.createdAt ||
            request.updatedAt ||
            request.reviewedAt ||
            null;

          if (!value) return 0;

          if (typeof value.toMillis === "function") {
            return value.toMillis();
          }

          if (typeof value.toDate === "function") {
            return value.toDate().getTime();
          }

          const parsedDate = new Date(value);
          return Number.isNaN(parsedDate.getTime()) ? 0 : parsedDate.getTime();
        };

        requests.sort(
          (firstRequest, secondRequest) =>
            getTimestamp(secondRequest) - getTimestamp(firstRequest),
        );

        setLatestRoleRequest(requests[0] || null);
      },
      (error) => {
        console.error("Помилка отримання заявки на зміну ролі:", error);
      },
    );

    return () => unsubscribe();
  }, [user?.uid]);
  useEffect(() => {
    const fetchProducts = async () => {
      const productsRef = collection(db, "product");
      const productsSnapshot = await getDocs(productsRef);
      const productsList = productsSnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setProducts(productsList);
    };
    fetchProducts();
  }, []);

  useEffect(() => {
    setRealUser(userBd);
  }, [userBd]);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollHeight = window.pageYOffset;
      setScrollHeight(currentScrollHeight);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleLogout = () => {
    signOut(auth)
      .then(() => navigate("/"))
      .catch((error) =>
        console.log("Помилка під час виходу з системи:", error),
      );
  };

  const handleBlockClick = (text) => setSelectedText(text);

  useEffect(() => {
    const fetchOrdersByUser = async () => {
      if (!user) return;
      try {
        const ordersRef = collection(db, "orders");
        const q = query(ordersRef, where("user", "==", user.uid));
        const querySnapshot = await getDocs(q);

        const parsedData = [];
        querySnapshot.forEach((doc) => {
          const order = { id: doc.id, ...doc.data() };
          const choice = JSON.parse(order.choice);
          choice.forEach((tovar) => parsedData.push({ order, tovar }));
        });

        let filteredData;
        if (selectedText === 2) {
          filteredData = parsedData.filter(
            ({ order }) => order.status === "Очікує підтвердження",
          );
        } else if (selectedText === 3) {
          filteredData =
            JSON.parse(localStorage.getItem("likedProducts")) || [];
        } else {
          filteredData = parsedData.filter(
            ({ order }) => order.status !== "Очікує підтвердження",
          );
        }
        setOrders(filteredData);

        if (selectedText !== 3) {
          const ttnNumbers = filteredData.map(({ order }) => order.status);
          const response = await axios.post(apiUrl, {
            apiKey: apiKey,
            modelName: "TrackingDocument",
            calledMethod: "getStatusDocuments",
            methodProperties: {
              Documents: ttnNumbers.map((status) => ({
                DocumentNumber: status,
              })),
            },
          });

          const statuses = response.data.data;
          const waitProdComponents =
            filteredData.length > 0 ? (
              filteredData.map(({ order, tovar }, index) => {
                const status =
                  statuses.find((s) => s.Number === order.status)?.Status ||
                  "Очікує підтвердження";
                return (
                  <WaitProd
                    key={index}
                    el={order}
                    tovar={tovar}
                    status={status}
                  />
                );
              })
            ) : (
              <p>{t("text001")}</p>
            );
          setWaitProdComponents(waitProdComponents);
        } else if (selectedText === 3) {
          const waitProdComponents = filteredData.map((tovar, index) => (
            <WaitProdLike
              key={index}
              tovar={tovar}
              setCartCounterC={setCartCounterC}
            />
          ));
          setWaitProdComponents(waitProdComponents);
        }
      } catch (error) {
        console.error("Помилка при отриманні замовлень:", error);
      }
    };

    fetchOrdersByUser();
  }, [user, selectedText, setCartCounterC, t]);

  const onClickToElefant = () => {
    alert(
      t("text002"),
    );
  };
  // десь поруч із іншими константами
  const MEMBER_LABEL = 'Член "Клубу Майстрів"';

  // після setRealUser(userBd) або нижче у блоці useEffect'ів
  useEffect(() => {
    if (!user || !realUser || realUser.category !== "Читач") return;

    (async () => {
      try {
        // 1) спроба оновити документ напряму по uid як id
        const directRef = doc(db, "users", user.uid);
        await updateDoc(directRef, { category: MEMBER_LABEL });
        setRealUser((prev) => ({ ...prev, category: MEMBER_LABEL }));
        return;
      } catch (_) {
        // 2) фолбек: шукаємо за полем uid
      }

      try {
        const q = query(collection(db, "users"), where("uid", "==", user.uid));
        const snap = await getDocs(q);
        if (snap.empty) return;
        await Promise.all(
          snap.docs.map((d) => updateDoc(d.ref, { category: MEMBER_LABEL })),
        );
        setRealUser((prev) => ({ ...prev, category: MEMBER_LABEL }));
      } catch (err) {
        console.error("Не вдалося оновити категорію користувача:", err);
      }
    })();
  }, [user, realUser]);
  // ✅ POPUP / EMAIL: стан і допоміжні речі
  const [showInvite, setShowInvite] = useState(false);

  const inviteSubject = t("inviteSubject");

  // ✅ ВІДРЕДАГОВАНИЙ ТЕКСТ ДЛЯ ДРУГА
  const inviteText = t("inviteText");

  const openMailInvite = () => {
    const href = `mailto:?subject=${encodeURIComponent(
      inviteSubject,
    )}&body=${encodeURIComponent(inviteText)}`;
    window.location.href = href;
  };

  const copyInvite = async () => {
    try {
      await navigator.clipboard.writeText(inviteText);
      alert(t("text005"));
    } catch {
      // фолбек, якщо clipboard API недоступний
      const el = document.createElement("textarea");
      el.value = inviteText;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      alert(t("text005"));
    }
  };

  // ✅ Мінімальні inline-стилі для модалки (щоб не лізти в CSS-модуль)
  const modalStyles = {
    overlay: {
      position: "fixed",
      inset: 0,
      background: "rgba(0,0,0,.5)",
      zIndex: 9999,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: 16,
    },
    modal: {
      background: "#fff",
      borderRadius: 12,
      width: "min(720px, 92vw)",
      maxHeight: "80vh",
      overflow: "auto",
      padding: 24,
      boxShadow: "0 10px 30px rgba(0,0,0,.2)",
    },
    h3: { margin: 0, marginBottom: 12 },
    p: { marginTop: 0, marginBottom: 12, lineHeight: 1.5 },
    textarea: {
      width: "90%",
      minHeight: 180,
      padding: 12,
      borderRadius: 8,
      border: "1px solid #ddd",
      resize: "vertical",
      fontFamily: "inherit",
    },
    btnRow: { display: "flex", gap: 12, marginTop: 12, flexWrap: "wrap" },
  };

  const handleClickInfo = () => setInfoTg(!infoTg);
  const changeInput = (e) => setTgId(e.target.value);
  useEffect(() => setInfoTg(false), [workFunc]);
  // --- BUSINESS PARTNER UI HELPERS ---
  const isBusiness = realUser?.category === "Бізнес-партнер";

  // знижка бізнес-партнера показується рівно така, як виставив адмін
  // (ніяких +5% за підписку)
  const BUSINESS_NOTE =
    t("BUSINESS_NOTE");

  // --- LIBRARIAN UI HELPERS ---
  const isLibrarian = realUser?.category === "Бібліотекар";
  const baseDiscount = Number(realUser?.discount) || 0;
  const isMaster = realUser?.category === "Майстер";
  // показуємо +5% лише в відображенні (для Librarian, коли signed==="true")
  const librarianDisplayedDiscount = isLibrarian
    ? baseDiscount + (realUser?.signed === "true" ? 0 : 0)
    : baseDiscount;

  const LIBRARIAN_NOTE =
    t("LIBRARIAN_NOTE");

  // const tgIdChange = async (uid) => {
  //   console.log("1890910399", uid);

  //   try {
  //     const usersRef = collection(db, "users");
  //     const q = query(usersRef, where("__name__", "==", uid));
  //     const querySnapshot = await getDocs(q);
  //     querySnapshot.forEach(async (docSnap) => {
  //       const userRef = docSnap.ref;
  //       await updateDoc(userRef, { telegramId: tgId });
  //     });
  //     setWorkFunc(!workFunc);
  //     // window.location.reload();
  //   } catch (error) {
  //     console.error("Помилка при оновленні значення telegramId:", error);
  //   }
  // };
  const tgIdChange = async (uid) => {
    const tgIdValue = String(tgId || "").trim(); // беремо зі стейту

    console.log("tgIdValue", tgIdValue);
    console.log("uid", uid);

    if (!uid || !tgIdValue) {
      console.error("uid або tgId відсутні", { uid, tgId: tgIdValue });
      return;
    }

    try {
      const directRef = doc(db, "users", uid);
      await updateDoc(directRef, { telegramId: tgIdValue });
      window.location.reload(); // лише після успіху
      return;
    } catch (_) {
      // фолбек, якщо id документа інший
    }

    try {
      const q = query(collection(db, "users"), where("uid", "==", uid));
      const snap = await getDocs(q);
      if (snap.empty) throw new Error("Користувача з таким uid не знайдено.");
      await Promise.all(
        snap.docs.map((d) => updateDoc(d.ref, { telegramId: tgIdValue })),
      );
      window.location.reload(); // лише після успішного запису
    } catch (err) {
      console.error("Помилка при оновленні telegramId:", err);
    }
  };
  // const openSet = () => setCheSetinings(!cheSetinings);
  const openSet = () => navigate(`/user/${user?.uid}`);

  const cabinetOptions = [
    { label: 'Член "Клубу Майстрів"', key: "club" },
    { label: "Бібліотекар", key: "librarian" },
    { label: "Майстер", key: "maister" },
    { label: "Бізнес-партнер", key: "business" },
  ];
  // лінки на Google-форми (можна перезаписати з Firestore: siteContent/userCabinet/forms.*)
  // const cabinetForms = {
  //   librarian:
  //     content?.forms?.librarian ?? "https://forms.gle/your-librarian-form",
  //   retailer:
  //     content?.forms?.retailer ?? "https://forms.gle/your-retailer-form",
  //   business:
  //     content?.forms?.business ?? "https://forms.gle/your-business-form",
  // };
  // const cabinetForms = {
  //   librarian:
  //     content?.forms?.librarian ?? "https://forms.gle/your-librarian-form",
  //   maister:
  //     content?.forms?.maister ??
  //     // сумісність: якщо ще не створив maister у Firestore
  //     content?.forms?.retailer ??
  //     "https://forms.gle/your-master-form",
  //   business:
  //     content?.forms?.business ?? "https://forms.gle/your-business-form",
  // };
  // скільки днів минуло після подачі заявки
  const daysSinceRequest = useMemo(() => {
    if (!cabinetRequest?.ts) return null;
    return Math.floor((Date.now() - cabinetRequest.ts) / (1000 * 60 * 60 * 24));
  }, [cabinetRequest]);

  // Фолбеки на випадок, якщо документ ще не створено в Firestore
  const heroMission =
    content?.hero?.missionText ??
    "Наша місія — допомогти батькам ростити дітей людьми, які вміють бути щасливими";
  const heroGoal =
    content?.hero?.goalText ??
    "Наша мета — створювати якісні дитячі книги, від яких важко відірватися, та які збагачують.";
  const tabs = content?.blocks ?? [
    { id: 1, title: "Статус замовлення" },
    { id: 2, title: "Чекають опрацювання" },
    { id: 3, title: "Бажане" },
  ];

  const facebookUrl =
    content?.socialLinks?.facebookUrl ??
    "https://www.facebook.com/chasmaistriv";
  const emailLink = content?.socialLinks?.email ?? "sales@chasmaistriv.com.ua";
  const telegramUrl =
    content?.socialLinks?.telegramUrl ?? "https://t.me/chas_maistriv";
  const viberUrl =
    content?.socialLinks?.viberUrl ??
    "https://invite.viber.com/?g2=AQBidB45Be8Vo057AydEGn81babrL0jatg7TIhXEIJeF4eMeFK1Qr4RQChEzk%2Fix";

  const unsigned = content?.discount?.unsigned;
  const signed = content?.discount?.signed;
  const handleCabinetSelect = async (opt) => {
    setShowCabinetMenu(false);

    if (opt.key === "club") {
      if (!user?.uid) {
        alert(t("text008"));
        return;
      }

      const nextCategory = 'Член "Клубу Майстрів"';

      // Якщо користувач уже має цю роль
      if (realUser?.category === nextCategory) {
        alert(t("text009"));
        return;
      }

      try {
        // Спочатку пробуємо users/{uid}
        const userRef = doc(db, "users", user.uid);

        await updateDoc(userRef, {
          category: nextCategory,
        });

        setRealUser((prev) => ({
          ...prev,
          category: nextCategory,
        }));

        localStorage.removeItem("cabinetRequest");
        setCabinetRequest(null);

        alert(t("text010"));
        return;
      } catch (directError) {
        console.warn(
          "Документ users/{uid} не знайдено. Виконуємо пошук за полем uid.",
          directError,
        );
      }

      try {
        // Запасний варіант, якщо ID документа не дорівнює UID
        const usersQuery = query(
          collection(db, "users"),
          where("uid", "==", user.uid),
        );

        const snapshot = await getDocs(usersQuery);

        if (snapshot.empty) {
          throw new Error("Користувача не знайдено в колекції users.");
        }

        await Promise.all(
          snapshot.docs.map((userDoc) =>
            updateDoc(userDoc.ref, {
              category: nextCategory,
            }),
          ),
        );

        setRealUser((prev) => ({
          ...prev,
          category: nextCategory,
        }));

        localStorage.removeItem("cabinetRequest");
        setCabinetRequest(null);

        alert(t("text010"));
      } catch (error) {
        console.error("Помилка зміни ролі користувача:", error);

        alert(
          t("text011"),
        );
      }

      return;
    }

    // Для інших ролей відкривається анкета
    setSelectedCabinetRole(opt);
    setShowRoleFormModal(true);
  };

  const menuStyles = {
    wrap: { position: "relative", display: "inline-block", marginLeft: 8 },
    btn: {
      border: "1px solid #3e51c1",
      background: "#3e51c1",
      color: "#fff",
      padding: "8px 12px",
      cursor: "pointer",
      fontSize: 19,
      lineHeight: 1,
      borderRadius: 0,
    },
    menu: {
      position: "absolute",
      top: "110%",
      right: 0,
      minWidth: 260,
      background: "#fff",
      border: "1px solid #e5e5e5",
      boxShadow: "0 10px 20px rgba(0,0,0,.08)",
      borderRadius: 8,
      zIndex: 50,
      overflow: "hidden",
    },
    item: {
      padding: "10px 12px",
      cursor: "pointer",
      borderBottom: "1px solid #f1f1f1",
      userSelect: "none",
    },
    itemLast: { borderBottom: "none" },
    note: {
      marginTop: 10,
      background: "#fff8e1",
      border: "1px solid #ffe08a",
      padding: "8px 12px",
      borderRadius: 8,
      fontSize: 14,
      lineHeight: 1.4,
    },
  };
  // відповідність ключа форми -> назва категорії в профілі
  // const cabinetKeyToCategory = {
  //   club: 'Член "Клубу Майстрів"',
  //   librarian: "Бібліотекар",
  //   retailer: "Продавець книг в книгарні",
  //   business: "Бізнес-партнер",
  // };
  const cabinetKeyToCategory = {
    club: 'Член "Клубу Майстрів"',
    librarian: "Бібліотекар",
    maister: "Майстер",
    business: "Бізнес-партнер",
  };
  useEffect(() => {
    if (cabinetRequest?.key === "retailer") {
      const migrated = { ...cabinetRequest, key: "maister", type: "Майстер" };
      localStorage.setItem("cabinetRequest", JSON.stringify(migrated));
      setCabinetRequest(migrated);
    }
  }, [cabinetRequest]);
  // якщо адміністратор вже змінив категорію — прибираємо локальний прапорець
  useEffect(() => {
    if (!realUser || !cabinetRequest) return;
    const expected = cabinetKeyToCategory[cabinetRequest.key];
    if (expected && realUser.category === expected) {
      localStorage.removeItem("cabinetRequest");
      setCabinetRequest(null);
    }
  }, [realUser, cabinetRequest]);
  useEffect(() => {
    if (!realUser || !cabinetRequest) return;

    // якщо роль користувача вже відповідає тій, на яку він подавав заявку –
    // прибираємо прапорець і банер
    if (realUser.category === cabinetRequest.type) {
      localStorage.removeItem("cabinetRequest");
      setCabinetRequest(null);
    }
  }, [realUser?.category, cabinetRequest]);
  const acknowledgeRoleRejection = async () => {
    if (!latestRoleRequest?.id || acknowledgingRejection) return;

    setAcknowledgingRejection(true);

    try {
      await updateDoc(doc(db, "roleChangeRequests", latestRoleRequest.id), {
        rejectionAcknowledged: true,
        rejectionAcknowledgedAt: serverTimestamp(),
        updatedAt: serverTimestamp(),
      });
      localStorage.removeItem("cabinetRequest");
      setCabinetRequest(null);
    } catch (error) {
      console.error("Не вдалося підтвердити ознайомлення з відмовою:", error);
      alert(t("text012"));
    } finally {
      setAcknowledgingRejection(false);
    }
  };
  const roleRequestAdminComment = latestRoleRequest?.adminComment?.trim() || "";

  const isRoleRequestRejected = latestRoleRequest?.status === "rejected";

  const shouldShowRoleRejection =
    isRoleRequestRejected && latestRoleRequest?.rejectionAcknowledged !== true;

  const shouldShowRoleAdminComment =
    Boolean(roleRequestAdminComment) && !isRoleRequestRejected;
  return (
    <>
      {realUser && (
        <div>
          <div className={css.bleuLabel}>
            <div className={css.blueLabelWnutr}>
              <p className={css.firstTextInBlock}>{heroMission}</p>
              <p className={css.firstTextInBlock}>{heroGoal}</p>
            </div>
          </div>
          {realUser && (
            <div className={css.userInformationWrap}>
              <div className={css.userInformationWrapSmall}>
                <div className={css.yourInformation}>
                  <div className={css.userData}>
                    <div className={css.imgAutorWrapSmall}>
                      {realUser.photo ? (
                        <img
                          src={realUser.photo}
                          className={css.imgAutorSmall}
                        />
                      ) : (
                        <img src={que} className={css.imgAutorSmall} />
                      )}
                    </div>
                    <div className={css.nameAndPropWr}>
                      {realUser.displayName ? (
                        <h4 className={css.userNameHello}>
                          {realUser.displayName}{t("text013")}</h4>
                      ) : (
                        <h4 className={css.userNameHello}>{t("text014")}</h4>
                      )}
                      <div className={css.propWrap}>
                        <div className={css.newdso}>
                          <img src={iconProp} />
                          <p className={css.propP} onClick={openSet}>{t("text015")}</p>
                        </div>
                        <UserChatBadge
                          uid={user?.uid}
                          onOpen={() => setOpenChat(true)}
                        />
                        <h2 className={css.outButton} onClick={handleLogout}>{t("text016")}</h2>
                      </div>
                      {cheSetinings && (
                        <ChangeData
                          scrollHeight={scrollHeight}
                          realUser={realUser}
                          setCheSetinings={setCheSetinings}
                          setRealUser={setRealUser}
                        />
                      )}
                    </div>
                  </div>
                  {windowDimensions ? (
                    <img src={Group16} className={css.iconPicBird} />
                  ) : (
                    <img src={Group17} className={css.iconPicBird} />
                  )}
                </div>
                <div className={css.ourInformation}>
                  {/* <h4 className={css.yourRegistration}>
                    {content?.registration?.prefix ?? "Ви зареєстровані як"}{" "}
                    {realUser.category}
                  </h4> */}
                  <h4
                    className={css.yourRegistration}
                    style={{ display: "flex", alignItems: "center", gap: 8 }}
                  >
                    {content?.registration?.prefix ?? t("label045")}{" "}
                    {realUser.category}
                    <span style={menuStyles.wrap}>
                      <button
                        type="button"
                        className={css.likeButton}
                        style={menuStyles.btn} // без заокруглень і без ховера
                        onClick={() => setShowCabinetMenu((v) => !v)}
                      >{t("text017")}</button>

                      {showCabinetMenu && (
                        <div style={menuStyles.menu}>
                          {cabinetOptions.map((opt, idx) => (
                            <div
                              key={opt.key}
                              style={{
                                ...menuStyles.item,
                                ...(idx === cabinetOptions.length - 1
                                  ? menuStyles.itemLast
                                  : null),
                              }}
                              onClick={() => handleCabinetSelect(opt)}
                              onKeyDown={(e) =>
                                e.key === "Enter" && handleCabinetSelect(opt)
                              }
                              role="button"
                              tabIndex={0}
                            >
                              {opt.label}
                            </div>
                          ))}
                        </div>
                      )}
                    </span>
                  </h4>

                  <SafeHtml className={css.yourDescription} html={registrationRoleHtml} />

                  {cabinetRequest &&
                    latestRoleRequest?.status !== "rejected" && (
                      <div style={menuStyles.note}>{t("text019")}{" "}
                        <b>{cabinetRequest.type}</b>{t("text020")}{typeof daysSinceRequest === "number" &&
                        daysSinceRequest >= 7 ? (
                          <>
                            {" "}{t("text021")}{" "}
                            <a href={`mailto:${emailLink}`}>{emailLink}</a>.
                          </>
                        ) : (
                          <>
                            {" "}{t("text022")}{" "}
                            <a href={`mailto:${emailLink}`}>{emailLink}</a>.
                          </>
                        )}
                      </div>
                    )}
                  {shouldShowRoleAdminComment && (
                    <div
                      style={{
                        marginTop: 12,
                        padding: "12px 14px",
                        background: "#eef3ff",
                        border: "1px solid #aebcff",
                        borderRadius: 8,
                        fontSize: 15,
                        lineHeight: 1.5,
                      }}
                    >
                      <strong>{t("text023")}</strong>

                      <div
                        style={{
                          marginTop: 6,
                          whiteSpace: "pre-wrap",
                        }}
                      >
                        {roleRequestAdminComment}
                      </div>
                    </div>
                  )}

                  {shouldShowRoleRejection && (
                    <div
                      style={{
                        marginTop: 12,
                        padding: "14px",
                        background: "#fff1f1",
                        border: "1px solid #e7a2a2",
                        borderRadius: 8,
                        fontSize: 15,
                        lineHeight: 1.5,
                      }}
                    >
                      <strong>{t("text024")}</strong>

                      <div
                        style={{
                          marginTop: 8,
                          whiteSpace: "pre-wrap",
                        }}
                      >
                        {roleRequestAdminComment ||
                          t("label046")}
                      </div>

                      <button
                        type="button"
                        className={css.likeButton}
                        onClick={acknowledgeRoleRejection}
                        disabled={acknowledgingRejection}
                        style={{
                          marginTop: 12,
                          cursor: acknowledgingRejection
                            ? "not-allowed"
                            : "pointer",
                          opacity: acknowledgingRejection ? 0.7 : 1,
                        }}
                      >
                        {acknowledgingRejection
                          ? t("label047")
                          : t("label048")}
                      </button>
                    </div>
                  )}
                  <div className={css.socialWrap}>
                    {facebookUrl && (<a
                      href={facebookUrl}
                      target="_blank"
                      rel="noreferrer noopener"
                    >
                      <div className={css.standartsocial}>
                        <img src={facForUs} />
                      </div>
                    </a>)}
                    <a
                      href={`mailto:${emailLink}`}
                      target="_blank"
                      rel="noreferrer noopener"
                    >
                      <div className={css.standartsocial}>
                        <img src={mailForSoc} />
                      </div>
                    </a>
                    {telegramUrl && (<a
                      href={telegramUrl}
                      target="_blank"
                      rel="noreferrer noopener"
                    >
                      <div className={css.standartsocial}>
                        <img src={tgUser} />
                      </div>
                    </a>)}
                    {viberUrl && (<a
                      href={viberUrl}
                      target="_blank"
                      rel="noreferrer noopener"
                    >
                      <div className={css.standartsocial}>
                        <img src={whatUser} />
                      </div>
                    </a>)}
                  </div>
                </div>
              </div>
            </div>
          )}
          {/* <div className={css.orderingProductWrap}>
            <div className={css.orderingProductWrapSmall}>
              <div className={css.wrapLab}>
                {tabs.map((block) => (
                  <div
                    key={block.id}
                    className={`${css.block} ${
                      block.id === selectedText ? css.selected : ""
                    }`}
                    onClick={() => handleBlockClick(block.id)}
                  >
                    {block.title}
                  </div>
                ))}
              </div>

              {waitProdComponents.length > 0 ? (
                <div className={css.waitOrderInPostWrap}>
                  {waitProdComponents}
                </div>
              ) : (
                <p></p>
              )}
            </div>
          </div> */}
          {/* {realUser?.category !== "Бізнес-партнер" && (
            <div className={css.orderingProductWrap}>
              <div className={css.orderingProductWrapSmall}>
                <div className={css.wrapLab}>
                  {tabs.map((block) => (
                    <div
                      key={block.id}
                      className={`${css.block} ${
                        block.id === selectedText ? css.selected : ""
                      }`}
                      onClick={() => handleBlockClick(block.id)}
                    >
                      {block.title}
                    </div>
                  ))}
                </div>

                {waitProdComponents.length > 0 ? (
                  <div className={css.waitOrderInPostWrap}>
                    {waitProdComponents}
                  </div>
                ) : (
                  <p></p>
                )}
              </div>
            </div>
          )}
          {realUser?.category === "Бізнес-партнер" && (
            <BusinessPartnerOrders user={user} />
          )} */}
          {realUser?.category === "Бізнес-партнер" ? (
            <BusinessPartnerOrders user={user} />
          ) : (
            <UserOrders user={user} />
          )}
          {realUser && realUser.signed === "false" && (
            <>
              {isLibrarian ? (
                /* ----------- ЛІБРАРІАН: НЕ ПІДПИСАНИЙ ----------- */
                <>
                  <div className={css.yourDiscountWrap}>
                    <div className={css.yourDiscountWrapSmall}>
                      <div className={css.dicsTextWr}>
                        <p className={css.yourDicrFive}>{t("text025")}<br />
                          <span className={css.yourDicrFiveSpan}>
                            {baseDiscount}%
                          </span>
                        </p>

                        <p className={css.yourDicrFiveSmall}>{t("text026")}</p>

                        <p
                          className={css.yourDicrFiveSmall}
                          style={{ marginTop: 8 }}
                        >
                          {LIBRARIAN_NOTE}
                        </p>
                      </div>

                      <img src={discIcon} className={css.discIconIc} />

                      <div className={css.buttonConfFRW}>
                        <p className={css.confirmP}>{t("text027")}</p>
                        <div
                          className={css.likeButton}
                          onClick={handleClickInfo}
                        >{t("text028")}</div>
                      </div>
                    </div>
                  </div>

                  {infoTg && (
                    <div className={css.yourDiscountWrapInfo}>
                      <div className={css.yourDiscountWrapSmall}>
                        <div className={css.dicsTextWrInfo}>
                          <p className={css.yourDicrFive}>
                            {unsigned?.stepsTitle ??
                              t("label049")}
                          </p>
                          <ol
                            className={css.yourDicrFiveSmall}
                            style={{ paddingLeft: 16 }}
                          >
                            {(unsigned?.steps ?? []).map((s, i) => (
                              <li key={i} style={{ marginBottom: 8 }}>
                                {s}
                              </li>
                            ))}
                          </ol>
                        </div>

                        <div className={css.buttonConfFRW}>
                          <a
                            className={css.likeButton}
                            href={
                              unsigned?.getIdBotUrl ?? "https://t.me/getidsbot"
                            }
                            target="_blank"
                            rel="noreferrer noopener"
                          >
                            <div className={css.likeButton}>{t("text029")}</div>
                          </a>

                          <input
                            className={css.inputTgId}
                            value={tgId}
                            placeholder={t("text030")}
                            onChange={(e) => setTgId(e.target.value)}
                          />

                          <a
                            className={css.likeButton}
                            href={
                              unsigned?.channelUrl ??
                              "https://t.me/chas_maistriv"
                            }
                            target="_blank"
                            rel="noreferrer noopener"
                          >
                            <div
                              className={css.likeButton}
                              onClick={() => tgIdChange(user.uid)}
                            >{t("text031")}</div>
                          </a>
                        </div>
                      </div>
                    </div>
                  )}
                </>
              ) : isBusiness ? (
                /* ----------- БІЗНЕС-ПАРТНЕР: НЕ ПІДПИСАНИЙ ----------- */
                <div className={css.yourDiscountWrap}>
                  <div className={css.yourDiscountWrapSmall}>
                    <div className={css.dicsTextWr}>
                      <p className={css.yourDicrFive}>{t("text032")}<br />
                        <span className={css.yourDicrFiveSpan}>
                          {baseDiscount}%
                        </span>
                      </p>

                      {/* без жодних підписок/додаткових 5% */}
                      <p className={css.yourDicrFiveSmall}>{BUSINESS_NOTE}</p>
                    </div>

                    <img src={discIcon} className={css.discIconIc} />

                    {/* Порожній правий блок (без "Інформація"/"Підписатись") */}
                    <div className={css.buttonConfFRW}>
                      <p
                        className={css.confirmP}
                        style={{
                          background: "#2e7d32",
                          color: "#fff",
                          padding: "8px 12px",
                          borderRadius: 8,
                          marginBottom: 8,
                          display: "inline-block",
                        }}
                      >{t("text033")}</p>

                      {businessTgUrl && (<a
                        href={businessTgUrl}
                        target="_blank"
                        rel="noreferrer noopener"
                        className={css.likeButton}
                        style={{
                          background: "#ffd54f",
                          color: "#000",
                          borderRadius: 8,
                          display: "inline-block",
                          textDecoration: "none",
                        }}
                      >{t("text034")}</a>)}
                    </div>
                  </div>
                </div>
              ) : (
                /* ----------- ІНШІ КАТЕГОРІЇ: як було ----------- */
                <>
                  <div className={css.yourDiscountWrap}>
                    <div className={css.yourDiscountWrapSmall}>
                      <div className={css.dicsTextWr}>
                        <p className={css.yourDicrFive}>
                          {unsigned?.title ?? t("label050")}
                          <br />
                          <span className={css.yourDicrFiveSpan}>
                            {realUser.discount}%
                          </span>
                        </p>
                        <p className={css.yourDicrFiveSmall}>
                          {unsigned?.subtitle ??
                            t("label051")}
                        </p>
                      </div>
                      <img src={discIcon} className={css.discIconIc} />
                      <div className={css.buttonConfFRW}>
                        <p className={css.confirmP}>{t("text027")}</p>
                        <div
                          className={css.likeButton}
                          onClick={handleClickInfo}
                        >{t("text028")}</div>
                      </div>
                    </div>
                  </div>

                  {infoTg && (
                    <div className={css.yourDiscountWrapInfo}>
                      <div className={css.yourDiscountWrapSmall}>
                        <div className={css.dicsTextWrInfo}>
                          <p className={css.yourDicrFive}>
                            {unsigned?.stepsTitle ??
                              t("label052")}
                          </p>
                          <ol
                            className={css.yourDicrFiveSmall}
                            style={{ paddingLeft: 16 }}
                          >
                            {(unsigned?.steps ?? []).map((s, i) => (
                              <li key={i} style={{ marginBottom: 8 }}>
                                {s}
                              </li>
                            ))}
                          </ol>
                        </div>

                        <div className={css.buttonConfFRW}>
                          <a
                            className={css.likeButton}
                            href={
                              unsigned?.getIdBotUrl ?? "https://t.me/getidsbot"
                            }
                            target="_blank"
                            rel="noreferrer noopener"
                          >
                            <div className={css.likeButton}>{t("text029")}</div>
                          </a>
                          <input
                            className={css.inputTgId}
                            value={tgId}
                            placeholder={t("text030")}
                            onChange={(e) => setTgId(e.target.value)}
                          />
                          <a
                            className={css.likeButton}
                            href={
                              unsigned?.channelUrl ??
                              "https://t.me/chas_maistriv"
                            }
                            target="_blank"
                            rel="noreferrer noopener"
                          >
                            <div
                              className={css.likeButton}
                              onClick={() => tgIdChange(user.uid)}
                            >{t("text031")}</div>
                          </a>
                        </div>
                      </div>
                    </div>
                  )}
                </>
              )}
            </>
          )}
          {realUser && realUser.signed === "true" && (
            <>
              {isLibrarian ? (
                /* ----------- ЛІБРАРІАН: ПІДПИСАНИЙ ----------- */
                <div className={css.yourDiscountWrap}>
                  <div className={css.yourDiscountWrapSmall}>
                    <div className={css.dicsTextWr}>
                      <p className={css.yourDicrFive}>{t("text025")}<br />
                        <span className={css.yourDicrFiveSpan}>
                          {librarianDisplayedDiscount}%
                        </span>
                      </p>
                      <p className={css.yourDicrFiveSmall}>{t("text035")}{baseDiscount - 5}{t("text036")}</p>
                      <p
                        className={css.yourDicrFiveSmall}
                        style={{ marginTop: 8 }}
                      >
                        {LIBRARIAN_NOTE}
                      </p>
                    </div>

                    <img src={discIcon} className={css.discIconIc} />

                    <div className={css.buttonConfFRW}>
                      <p className={css.confirmP}>{t("text037")}</p>
                      <button
                        type="button"
                        className={`${css.likeButton} ${css.inviteBtn} ${css.noRadius}`}
                        onClick={() => setShowInvite(true)}
                      >{t("text037")}</button>
                    </div>
                  </div>

                  {showInvite && (
                    <div
                      style={modalStyles.overlay}
                      onClick={() => setShowInvite(false)}
                    >
                      <div
                        style={modalStyles.modal}
                        onClick={(e) => e.stopPropagation()}
                      >
                        <h3 style={modalStyles.h3}>{t("text037")}</h3>
                        <p style={modalStyles.p}>{t("text038")}</p>
                        <textarea
                          readOnly
                          style={modalStyles.textarea}
                          value={inviteText}
                        />
                        <div style={modalStyles.btnRow}>
                          <button
                            type="button"
                            className={`${css.likeButton} ${css.inviteBtn} ${css.noRadius}`}
                            onClick={copyInvite}
                          >{t("text039")}</button>
                          <button
                            type="button"
                            className={`${css.likeButton} ${css.inviteBtn} ${css.noRadius}`}
                            onClick={openMailInvite}
                          >{t("text040")}</button>
                          <button
                            type="button"
                            className={`${css.likeButton} ${css.inviteBtn} ${css.noRadius}`}
                            onClick={() => setShowInvite(false)}
                          >{t("text041")}</button>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              ) : isBusiness ? (
                /* ----------- БІЗНЕС-ПАРТНЕР: ПІДПИСАНИЙ ----------- */
                <div className={css.yourDiscountWrap}>
                  <div className={css.yourDiscountWrapSmall}>
                    <div className={css.dicsTextWr}>
                      <p className={css.yourDicrFive}>{t("text032")}<br />
                        <span className={css.yourDicrFiveSpan}>
                          {baseDiscount}%
                        </span>
                      </p>
                      {/* жодного +5% за підписку */}
                      <p className={css.yourDicrFiveSmall}>{BUSINESS_NOTE}</p>
                    </div>

                    <img src={discIcon} className={css.discIconIc} />

                    {/* за бажанням можна лишити запрошення друга; якщо не потрібно — залиш так */}
                    <div className={css.buttonConfFRW}>
                      <p
                        className={css.confirmP}
                        style={{
                          color: "#fff",
                          padding: "8px 12px",
                          borderRadius: 8,
                          marginBottom: 8,
                          display: "inline-block",
                        }}
                      >{t("text033")}</p>

                      {businessTgUrl && (<a
                        href={businessTgUrl}
                        target="_blank"
                        rel="noreferrer noopener"
                        className={css.likeButton}
                      >{t("text034")}</a>)}
                    </div>
                  </div>
                </div>
              ) : (
                /* ----------- ІНШІ КАТЕГОРІЇ: як було ----------- */
                <div className={css.yourDiscountWrap}>
                  <div className={css.yourDiscountWrapSmall}>
                    <div className={css.dicsTextWr}>
                      <p className={css.yourDicrFive}>
                        {signed?.noteTitle ?? t("label050")}
                        <br />
                        <span className={css.yourDicrFiveSpan}>
                          {realUser.discount}%
                        </span>
                      </p>
                      <p className={css.yourDicrFiveSmall}>
                        {signed?.note ??
                          t("label053")}
                      </p>
                    </div>

                    <img src={discIcon} className={css.discIconIc} />

                    <div className={css.buttonConfFRW}>
                      {isMaster ? (
                        <>
                          <p className={css.confirmP}>{t("text037")}</p>
                          <button
                            type="button"
                            className={`${css.likeButton} ${css.inviteBtn} ${css.noRadius}`}
                            onClick={() => setShowInvite(true)}
                          >{t("text037")}</button>
                        </>
                      ) : (
                        <>
                          <p className={css.confirmP}>{t("text042")}</p>
                          <button
                            type="button"
                            className={`${css.likeButton} ${css.inviteBtn} ${css.noRadius}`}
                            onClick={() => setShowInvite(true)}
                          >
                            {signed?.inviteCta ?? t("label054")}
                          </button>
                        </>
                      )}
                    </div>
                  </div>

                  {showInvite && (
                    <div
                      style={modalStyles.overlay}
                      onClick={() => setShowInvite(false)}
                    >
                      <div
                        style={modalStyles.modal}
                        onClick={(e) => e.stopPropagation()}
                      >
                        <h3 style={modalStyles.h3}>{t("text042")}</h3>
                        <p style={modalStyles.p}>{t("text038")}</p>
                        <textarea
                          readOnly
                          style={modalStyles.textarea}
                          value={inviteText}
                        />
                        <div style={modalStyles.btnRow}>
                          <button
                            type="button"
                            className={`${css.likeButton} ${css.inviteBtn} ${css.noRadius}`}
                            onClick={copyInvite}
                          >{t("text039")}</button>
                          <button
                            type="button"
                            className={`${css.likeButton} ${css.inviteBtn} ${css.noRadius}`}
                            onClick={openMailInvite}
                          >{t("text040")}</button>
                          <button
                            type="button"
                            className={`${css.likeButton} ${css.inviteBtn} ${css.noRadius}`}
                            onClick={() => setShowInvite(false)}
                          >{t("text041")}</button>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </>
          )}
          {realUser.category === "Бібліотекар" && <LibraryOffersBanner />}
          {realUser.category === "Бібліотекар" && <LibraryCatalogBanner />}
          {realUser.category === "Бізнес-партнер" && (
            <CommercialNewsBanner />
          )}{" "}
          {realUser.category === "Бізнес-партнер" && <CabinetTilesDynamiс />}{" "}
          {realUser.category === "Бізнес-партнер" && <BusinessInvoices />}
          {realUser.category === 'Член "Клубу Майстрів"' && <BlockReader />}
          {/* {realUser.category === "Читач" && <BlockReader />} */}
          {realUser.category === "Бізнес-партнер" && (
            <BlockBusiness userBd={realUser} />
          )}
          {realUser.category === "Бібліотекар" && <BlockLibrarian />}
          {realUser.category === "Майстер" && (
            <BlockMaister userBd={realUser} />
          )}
          {realUser.category === 'Член "Клубу Майстрів"' && (
            <div className={css.elefantWrap} onClick={onClickToElefant}>
              <div className={css.elefantWrapSmall}>
                <div className={css.elef}>
                  <img src={elefant} className={css.elefant} />
                  <p className={css.howMathElefant}>{t("text043")}<br />
                    <span className={css.howMathElefantSpan}>
                      {realUser.elefant}
                    </span>
                  </p>
                </div>
                <div className={css.elefantDescription}>
                  <SafeHtml
                    html={content?.elephants?.leadHtml ??
                        "Ви можете <br /> сплачувати слонами <br /> за наші книги"}
                  />
                  <span className={css.elefantDescriptionSpan}>{content?.elephants?.infoReader ?? ""}</span>
                </div>
              </div>
            </div>
          )}
          <ViewProductCatalog
            products={products}
            setCartCounterC={setCartCounterC}
            setLikeCounterC={setLikeCounterC}
          />
          {showRoleFormModal && selectedCabinetRole && (
            <RoleChangeFormModal
              role={selectedCabinetRole}
              user={user}
              realUser={realUser}
              onClose={() => {
                setShowRoleFormModal(false);
                setSelectedCabinetRole(null);
              }}
              onSuccess={(req) => {
                localStorage.setItem("cabinetRequest", JSON.stringify(req));
                setCabinetRequest(req);
                setShowRoleFormModal(false);
                setSelectedCabinetRole(null);
              }}
            />
          )}
          {openChat && (
            <UserChat
              uid={user?.uid}
              userProfile={realUser}
              onClose={() => setOpenChat(false)}
            />
          )}
        </div>
      )}
    </>
  );
};
export default withCabinetContent(withUserData(UserCabinet));
